/* Module werden dynamisch über die versionierten asset_url-Pfade aus dem Konfig-JSON
 * geladen (cfg.module.*), nicht über statische relative Imports: Shopifys CDN cacht
 * ".../tn3d-modell.js" sonst unabhängig vom aktuellen Theme-Stand, was nach einem Push
 * zu veralteten Modulen (fehlende Exporte) führen kann (Schritt 2b). */
const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
const ralCode = (v) => String(v || "").replace(/^RAL\s*/i, "");
const r2 = (x) => Math.round(x * 100) / 100;
const TUCH_FARBE = { "Cremeweiß": "#f4e6c0", "Hellgrau": "#9b9b9b", "Beige": "#c4a98a" };
const ZB_ICON = {
  "Klassisch": '<path d="M28 4h-8c-3 0-4 3-4 6v4c0 3 3 4 6 5s4 3 4 6v6c0 3-2 4-4 5s-3 2-3 4v2"/>',
  "Rund": '<path d="M27 4C14 12 12 30 25 42"/>',
  "Flach": '<path d="M22 4v38"/>'
};
const LOCALE_TAG = { de: "de-DE", en: "en-GB", nl: "nl-NL" };
function markisenPreis(n, bahnbreite, bahnlaenge, k) {
  const netto = bahnbreite * bahnlaenge / 1e4 * n * (k.stoff + k.stechhaken + k.lohn) + bahnlaenge * 1.1 * 2 * n / 100 * k.drahtseil + bahnlaenge * 2 * n / 100 * k.gardinenband + 4 * n * k.spanner + k.versandPolen + k.versandKunde;
  return r2(netto * 1.19);
}
async function init(root) {
  if (root.__tn3d) return;
  root.__tn3d = true;
  const cfgEl = root.querySelector("script[data-tn3d-config]");
  const cfg = JSON.parse(cfgEl.textContent);
  const i18nEl = root.querySelector("script[data-tn3d-i18n]");
  const i18nDict = i18nEl ? JSON.parse(i18nEl.textContent) : {};
  const [modell, urlMod, lieferumfangMod, angebotMod, pdfMod, i18nMod] = await Promise.all([
    import(cfg.module.modell),
    import(cfg.module.url),
    import(cfg.module.lieferumfang),
    import(cfg.module.angebot),
    import(cfg.module.pdf),
    import(cfg.module.i18n)
  ]);
  const { TerrneeVisualizer, RAL, felderGleichmaessig, berechnePreis, wandanschlussCm } = modell;
  const { configZuQuery, configZuLink, configAusQuery } = urlMod;
  const { erstelleLieferumfang, bauListen } = lieferumfangMod;
  const { erstelleAngebotModal, pruefeKontaktRueckkehr } = angebotMod;
  const { exportierePdf } = pdfMod;
  const { erstelleT } = i18nMod;
  const T = erstelleT(i18nDict);
  const sprache = cfg.sprache || "de";
  const root_ = (cfg.root || "/").replace(/\/*$/, "/");
  const eur = new Intl.NumberFormat(LOCALE_TAG[sprache] || "de-DE", { style: "currency", currency: "EUR" });
  const kg = new Intl.NumberFormat(LOCALE_TAG[sprache] || "de-DE", { maximumFractionDigits: 2 });
  const modus = cfg.modus || "terrasse";
  const base = cfg.assetBase || "./";
  const L = cfg.limits;
  const preisCfg = {
    versand: cfg.preis.versand,
    ledLoseBrutto: cfg.preis.ledLose,
    ledVormontageBrutto: cfg.preis.ledVormontage,
    markiseKalkBahnCm: cfg.preis.markiseKalkBahnCm,
    rabattProzent: cfg.preis.rabattProzent,
    mwst: 0.19,
    markise: cfg.preis.markise,
    gitter: cfg.preis.gitter
  };
  const zbBild = (z) => {
    const name = z === "Modern" ? "Flach" : z;
    const url = (cfg.zierblendeBilder || {})[name];
    return url ? `<img class="tn3d-foto" src="${esc(url)}" alt="${esc(T("zierblende.alt", { name: T(`werte.zierblende.${name}`) }))}" loading="lazy" width="160" height="160">` : `<svg class="tn3d-foto tn3d-foto--icon" viewBox="0 0 46 46" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">${ZB_ICON[name] || ""}</g></svg>`;
  };
  const state = modus === "markise" ? { modus, anzahl: 4, bahnbreite_cm: 90, bahnlaenge_cm: 300, tuchfarbe: cfg.tuchfarben[0] || "Cremeweiß", rahmenfarbe: "7016", material: "polycarbonat", ausfuehrung: "Klar", zierblende: "Klassisch" } : {
    modus,
    breite_cm: 500,
    tiefe_cm: 300,
    pfostenhoehe_cm: cfg.pfostenhoeheCm || 250,
    rahmenfarbe: cfg.rahmenfarben.includes("RAL 7016") ? "RAL 7016" : cfg.rahmenfarben[0],
    zierblende: cfg.zierblenden[0] || "Klassisch",
    material: "polycarbonat",
    ausfuehrung: cfg.polyVarianten[0] || "Klar",
    markise_aktiv: modus === "komplett",
    tuchfarbe: cfg.tuchfarben[0] || "Cremeweiß",
    led_aktiv: false,
    led_farbe: "3000K",
    led_montage: "lose"
  };
  const urlUeberschreibung = configAusQuery(modus);
  if (urlUeberschreibung) {
    if (modus === "markise") {
      if (urlUeberschreibung.tuchfarbe && cfg.tuchfarben.includes(urlUeberschreibung.tuchfarbe)) state.tuchfarbe = urlUeberschreibung.tuchfarbe;
      ["anzahl", "bahnbreite_cm", "bahnlaenge_cm"].forEach((k) => {
        if (typeof urlUeberschreibung[k] === "number") state[k] = urlUeberschreibung[k];
      });
    } else {
      if (urlUeberschreibung.material === "polycarbonat" || urlUeberschreibung.material === "glas") state.material = urlUeberschreibung.material;
      const ausfuehrungListe = state.material === "glas" ? cfg.glasVarianten : cfg.polyVarianten;
      if (urlUeberschreibung.ausfuehrung && ausfuehrungListe.includes(urlUeberschreibung.ausfuehrung)) state.ausfuehrung = urlUeberschreibung.ausfuehrung;
      if (urlUeberschreibung.rahmenfarbe && cfg.rahmenfarben.includes(urlUeberschreibung.rahmenfarbe)) state.rahmenfarbe = urlUeberschreibung.rahmenfarbe;
      if (urlUeberschreibung.zierblende && cfg.zierblenden.includes(urlUeberschreibung.zierblende)) state.zierblende = urlUeberschreibung.zierblende;
      if (typeof urlUeberschreibung.breite_cm === "number") state.breite_cm = urlUeberschreibung.breite_cm;
      if (typeof urlUeberschreibung.tiefe_cm === "number") state.tiefe_cm = urlUeberschreibung.tiefe_cm;
      if (modus === "terrasse" && typeof urlUeberschreibung.markise_aktiv === "boolean") state.markise_aktiv = urlUeberschreibung.markise_aktiv;
      if (urlUeberschreibung.tuchfarbe && cfg.tuchfarben.includes(urlUeberschreibung.tuchfarbe)) state.tuchfarbe = urlUeberschreibung.tuchfarbe;
      if (urlUeberschreibung.led_aktiv) {
        state.led_aktiv = true;
        state.led_farbe = urlUeberschreibung.led_farbe === "6000K" ? "6000K" : "3000K";
        state.led_montage = urlUeberschreibung.led_montage === "vormontiert" ? "vormontiert" : "lose";
      }
    }
  }
  const tuchOpts = cfg.tuchfarben.map((t) => `<button type="button" class="tn3d-opt" data-v="${esc(t)}"><span class="tn3d-swatch tn3d-swatch--stoff" style="background-color:${TUCH_FARBE[t] || "#ccc"}${(cfg.stoffBilder || {})[t] ? `;background-image:url(${esc(cfg.stoffBilder[t])})` : ""}"></span>${esc(T(`werte.tuchfarbe.${t.replace("ß","ss")}`))}</button>`).join("");
  const markiseInfo = `
    <p class="tn3d-hinweis-titel">${esc(T("markise_info.titel"))}</p>
    <ul class="tn3d-liste">
      <li>${esc(T("markise_info.punkt1"))}</li>
      <li>${esc(T("markise_info.punkt2"))}</li>
      <li>${esc(T("markise_info.punkt3"))}</li>
      <li>${esc(T("markise_info.punkt4"))}</li>
      <li>${esc(T("markise_info.punkt5"))}</li>
    </ul>`;
  let panel = "";
  if (modus === "markise") {
    panel += `
      <div class="tn3d-grp">
        <h3 class="tn3d-h">${esc(T("masse.titel_stoffbahnen"))}</h3>
        ${stepper("anzahl", T("masse.anzahl_stoffbahnen"), T("masse.anzahl_hint", { min: L.bahnenMin, max: L.bahnenMax }), L.bahnenMin, L.bahnenMax, 1, "")}
        ${stepper("bahnbreite_cm", T("masse.breite_je_bahn"), T("allgemein.bereich_cm", { min: L.bahnbreiteMin, max: L.bahnbreiteMax }), L.bahnbreiteMin, L.bahnbreiteMax, 1, "cm")}
        ${stepper("bahnlaenge_cm", T("masse.laenge_der_bahnen"), T("allgemein.bereich_cm", { min: L.bahnlaengeMin, max: L.bahnlaengeMax }), L.bahnlaengeMin, L.bahnlaengeMax, 1, "cm")}
        <p class="tn3d-info">${esc(T("masse.mess_hinweis"))} <a href="${esc(root_)}pages/richtig-messen-seilspannmarkise">${esc(T("masse.so_messen_sie_richtig"))}</a></p>
      </div>
      <div class="tn3d-grp">
        <h3 class="tn3d-h">${esc(T("masse.stofffarbe"))}</h3>
        <div class="tn3d-opts" data-key="tuchfarbe">${tuchOpts}</div>
        <div class="tn3d-hinweis">
          <p class="tn3d-hinweis-titel">${esc(T("masse.fuer_vorhandene"))}</p>
          <ul class="tn3d-liste">
            <li>${esc(T("masse.montage_sparren"))}</li>
            <li>${esc(T("masse.bedienung_hand"))}</li>
            <li>${esc(T("masse.montagematerial_inklusive"))}</li>
            <li>${esc(T("masse.polyester_eigenschaften"))}</li>
          </ul>
          <p class="tn3d-info">${T("masse.komplett_hinweis", { link: `<a href="${esc(root_)}collections/konfigurator-komplettsystem">${esc(T("masse.komplettsystem"))}</a>` })}</p>
        </div>
      </div>`;
  } else {
    panel += `
      <div class="tn3d-grp">
        <h3 class="tn3d-h">${esc(T("masse.titel_ueberdachung"))}</h3>
        ${stepper("breite_cm", T("masse.breite"), "", L.breiteMin, L.breiteMax, 1, "cm")}
        ${stepper("tiefe_cm", T("masse.tiefe"), "", L.tiefeMin, L.tiefeMaxPoly, 1, "cm")}
        <p class="tn3d-info" data-tn3d-info></p>
        <p class="tn3d-info" data-tn3d-wandanschluss></p>
      </div>
      <div class="tn3d-grp">
        <h3 class="tn3d-h">${esc(T("masse.rahmenfarbe"))} <small data-tn3d-farbname></small></h3>
        <div class="tn3d-opts" data-key="rahmenfarbe">${cfg.rahmenfarben.map((f) => {
      const r = RAL[ralCode(f)] || { hex: "#888" };
      return `<button type="button" class="tn3d-opt" data-v="${esc(f)}"><span class="tn3d-swatch" style="background:${r.hex}"></span>${esc(f)}</button>`;
    }).join("")}</div>
      </div>
      <div class="tn3d-grp">
        <h3 class="tn3d-h">${esc(T("masse.zierblende"))}</h3>
        <div class="tn3d-opts" data-key="zierblende">${cfg.zierblenden.map((z) => `<button type="button" class="tn3d-opt" data-v="${esc(z)}">${zbBild(z)}${esc(T(`werte.zierblende.${z === "Modern" ? "Flach" : z}`))}</button>`).join("")}</div>
      </div>
      <div class="tn3d-grp">
        <h3 class="tn3d-h">${esc(T("masse.dacheindeckung"))}</h3>
        <div class="tn3d-opts tn3d-opts--2" data-key="dach">
          ${cfg.polyVarianten.map((v) => `<button type="button" class="tn3d-opt" data-v="polycarbonat:${esc(v)}"><span class="tn3d-swatch tn3d-swatch--poly${v === "Opal" ? "-opal" : ""}"></span>${esc(T("werte.material.polycarbonat"))} ${esc(T(`werte.ausfuehrung.${v}`))}<small>${esc(T("masse.stegplatte"))}</small></button>`).join("")}
          ${cfg.glasVarianten.map((v) => `<button type="button" class="tn3d-opt" data-v="glas:${esc(v)}"><span class="tn3d-swatch tn3d-swatch--glas${v === "Matt" ? "-matt" : ""}"></span>${esc(T("werte.material.glas"))} ${esc(T(`werte.ausfuehrung.${v}`))}<small>${esc(T("masse.vsg_glas"))}</small></button>`).join("")}
        </div>
        <p class="tn3d-info">${esc(T("masse.dach_hinweis"))}</p>
      </div>
      <div class="tn3d-grp">
        ${modus === "komplett" ? `<h3 class="tn3d-h">${esc(T("markise_toggle.titel"))}</h3>` : `<div class="tn3d-toggle"><h3 class="tn3d-h">${esc(T("markise_toggle.titel"))} <small>${esc(T("markise_toggle.hinweis"))}</small></h3><label class="tn3d-switch"><input type="checkbox" data-tn3d-markise aria-label="${esc(T("markise_toggle.aria"))}"><span></span></label></div>`}
        <div data-tn3d-markisebox ${modus === "komplett" ? "" : "hidden"}>
          <div class="tn3d-hinweis">${markiseInfo}</div>
          <p class="tn3d-unter">${esc(T("masse.stofffarbe"))}</p>
          <div class="tn3d-opts" data-key="tuchfarbe">${tuchOpts}</div>
        </div>
      </div>
      <div class="tn3d-grp">
        <div class="tn3d-toggle"><h3 class="tn3d-h">${esc(T("led.titel"))}</h3><label class="tn3d-switch"><input type="checkbox" data-tn3d-led aria-label="${esc(T("led.aria"))}"><span></span></label></div>
        <div data-tn3d-ledbox hidden>
          <div class="tn3d-hinweis">
            <p class="tn3d-hinweis-titel">${esc(T("led.info_titel"))}</p>
            <ul class="tn3d-liste">
              <li>${esc(T("led.punkt1"))}</li>
              <li>${esc(T("led.punkt2"))}</li>
              <li>${esc(T("led.punkt3"))}</li>
            </ul>
          </div>
          <p class="tn3d-unter">${esc(T("led.lichtfarbe"))}</p>
          <div class="tn3d-seg" data-key="led_farbe">
            <button type="button" data-v="3000K"><span><i class="tn3d-licht" style="background:#ffd59a"></i> ${esc(T("led.warmweiss_label"))}</span><small>3000 K</small></button>
            <button type="button" data-v="6000K"><span><i class="tn3d-licht" style="background:#e6efff"></i> ${esc(T("led.kaltweiss_label"))}</span><small>6000 K</small></button>
          </div>
          <p class="tn3d-unter">${esc(T("led.lieferung"))}</p>
          <div class="tn3d-seg" data-key="led_montage">
            <button type="button" data-v="lose">${esc(T("led.lose_beigelegt"))}<small>${eur.format(preisCfg.ledLoseBrutto)}</small></button>
            <button type="button" data-v="vormontiert">${esc(T("led.vormontiert_an_sparren"))}<small>${eur.format(preisCfg.ledLoseBrutto + preisCfg.ledVormontageBrutto)}</small></button>
          </div>
        </div>
      </div>`;
  }
  root.innerHTML = `
    <div class="tn3d-app">
      <div class="tn3d-viewer" data-tn3d-viewer>
        <div class="tn3d-toolbar">
          <button type="button" class="tn3d-chip" data-tn3d-masse aria-pressed="true">${esc(T("toolbar.masse"))}</button>
          <button type="button" class="tn3d-chip" data-tn3d-reset>${esc(T("toolbar.ansicht_zuruecksetzen"))}</button>
          <div class="tn3d-kulissen" role="group" aria-label="${esc(T("toolbar.umgebung"))}">
            <button type="button" data-k="neutral">${esc(T("toolbar.neutral"))}</button>
            <button type="button" data-k="garten">${esc(T("toolbar.garten"))}</button>
            <button type="button" data-k="modern">${esc(T("toolbar.modern"))}</button>
          </div>
        </div>
        <div class="tn3d-preis" aria-live="polite">
          <div class="tn3d-preis-kopf" data-tn3d-ptitel></div>
          <div class="tn3d-preis-summe" data-tn3d-psumme>–</div>
          <div class="tn3d-preis-steuer">${esc(T("preis.inkl_mwst_versand"))}</div>
          <span class="tn3d-badge" data-tn3d-pbadge hidden>${esc(T("preis.komplettsystem_rabatt_badge", { prozent: preisCfg.rabattProzent }))}</span>
          <dl class="tn3d-preis-liste" data-tn3d-pliste></dl>
          <button type="button" class="tn3d-cta" data-tn3d-cta><span>${esc(T("preis.in_den_warenkorb"))}</span></button>
          <button type="button" class="tn3d-cta-sekundaer" data-tn3d-angebot>${esc(T("preis.angebot_anfragen"))}</button>
          <button type="button" class="tn3d-cta-pdf" data-tn3d-pdf><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12m0 0l-4-4m4 4l4-4M4 17v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg><span>${esc(T("preis.uebersicht_als_pdf"))}</span></button>
        </div>
      </div>
      <div class="tn3d-panel">
        ${panel}
        <div class="tn3d-summe">
          <div><span data-tn3d-ptitel2></span><strong data-tn3d-psumme2>–</strong><small>${esc(T("preis.inkl_mwst_versand"))}</small></div>
          <div class="tn3d-summe-aktionen">
          <button type="button" class="tn3d-cta" data-tn3d-cta><span>${esc(T("preis.in_den_warenkorb"))}</span></button>
          <button type="button" class="tn3d-cta-sekundaer" data-tn3d-angebot>${esc(T("preis.angebot_anfragen"))}</button>
          <button type="button" class="tn3d-cta-pdf" data-tn3d-pdf><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12m0 0l-4-4m4 4l4-4M4 17v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg><span>${esc(T("preis.uebersicht_als_pdf"))}</span></button>
          </div>
        </div>
        <p class="tn3d-fehler" data-tn3d-fehler role="alert" hidden></p>
      </div>
    </div>`;
  function stepper(key, label, hint, min, max, step, unit) {
    return `<div class="tn3d-feld" data-feld="${key}">
      <label class="tn3d-label" for="tn3d-${key}">${esc(label)}<span data-hint="${key}">${esc(hint)}</span></label>
      <div class="tn3d-stepper">
        <button type="button" data-step="-1" aria-label="${esc(T("rahmenfarbe.verringern", { label }))}">−</button>
        <input id="tn3d-${key}" type="number" inputmode="numeric" min="${min}" max="${max}" step="${step}" data-input="${key}">
        <span class="tn3d-unit">${esc(unit)}</span>
        <button type="button" data-step="1" aria-label="${esc(T("rahmenfarbe.erhoehen", { label }))}">+</button>
      </div>
      <input type="range" min="${min}" max="${max}" step="${step}" data-range="${key}" aria-label="${esc(label)}">
    </div>`;
  }
  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => Array.from(root.querySelectorAll(sel));
  function grenzen() {
    if (modus === "markise") return { anzahl: [L.bahnenMin, L.bahnenMax], bahnbreite_cm: [L.bahnbreiteMin, L.bahnbreiteMax], bahnlaenge_cm: [L.bahnlaengeMin, L.bahnlaengeMax] };
    const glas = state.material === "glas";
    let maxB = L.breiteMax;
    if (state.markise_aktiv) maxB = Math.min(maxB, L.bahnenMax * (glas ? 78 : 98));
    return { breite_cm: [L.breiteMin, maxB], tiefe_cm: [L.tiefeMin, glas ? L.tiefeMaxGlas : L.tiefeMaxPoly] };
  }
  function vizParams() {
    if (modus !== "markise") {
      return Object.assign({}, state, { rahmenfarbe: ralCode(state.rahmenfarbe) });
    }
    const n = state.anzahl, feld = state.bahnbreite_cm + 1;
    return {
      modus: "markise",
      felder_cm: Array.from({ length: n }, () => feld),
      breite_cm: n * feld,
      tiefe_cm: state.bahnlaenge_cm + 8,
      bahnbreite_cm: state.bahnbreite_cm,
      bahnlaenge_cm: state.bahnlaenge_cm,
      markise_aktiv: true,
      tuchfarbe: state.tuchfarbe,
      rahmenfarbe: "7016",
      material: "polycarbonat",
      ausfuehrung: "Klar",
      zierblende: "Klassisch"
    };
  }
  function preis() {
    if (modus === "markise") {
      const p2 = markisenPreis(state.anzahl, state.bahnbreite_cm, state.bahnlaenge_cm, preisCfg.markise);
      return { gesamt: p2, zeilen: [[T("preis.zeile.seilspannmarkise_bahnen", { anzahl: state.anzahl, bahnwort: T(state.anzahl === 1 ? "allgemein.bahn" : "allgemein.bahnen") }), eur.format(p2)]], titel: T("preis.titel.markise") };
    }
    const p = berechnePreis(state, preisCfg);
    const zeilen = [[T("preis.zeile.ueberdachung"), eur.format(p.dach)]];
    if (state.led_aktiv) zeilen.push([T("preis.zeile.led_spots", { farbe: T(state.led_farbe === "6000K" ? "werte.kaltweiss" : "werte.warmweiss") }), eur.format(p.led)]);
    if (state.markise_aktiv) {
      zeilen.push([T("preis.zeile.seilspannmarkise"), eur.format(p.markise)]);
      zeilen.push([T("preis.zeile.komplettsystem_rabatt", { prozent: preisCfg.rabattProzent }), "−" + eur.format(p.rabatt), "rabatt"]);
    }
    return { gesamt: p.gesamt, zeilen, titel: state.markise_aktiv ? T("preis.titel.komplett") : T("preis.titel.terrasse"), roh: p };
  }
  function anzeigen() {
    const g = grenzen();
    Object.keys(g).forEach((k) => {
      const [mn, mx] = g[k];
      if (state[k] > mx) state[k] = mx;
      if (state[k] < mn) state[k] = mn;
      const inp = $(`[data-input="${k}"]`), rg = $(`[data-range="${k}"]`), h = $(`[data-hint="${k}"]`);
      if (inp) {
        inp.min = mn;
        inp.max = mx;
        if (document.activeElement !== inp) inp.value = state[k];
      }
      if (rg) {
        rg.min = mn;
        rg.max = mx;
        rg.value = state[k];
      }
      if (h && (k === "breite_cm" || k === "tiefe_cm")) {
        h.textContent = T("allgemein.bereich_cm", { min: mn, max: mx }) + (k === "tiefe_cm" && state.material === "glas" ? T("masse.bei_glas") : "") + (k === "breite_cm" && mx < L.breiteMax ? T("masse.mit_markise") : "");
      }
    });
    const p = preis();
    $$("[data-tn3d-ptitel],[data-tn3d-ptitel2]").forEach((e) => {
      e.textContent = p.titel;
    });
    $$("[data-tn3d-psumme],[data-tn3d-psumme2]").forEach((e) => {
      e.textContent = eur.format(p.gesamt);
    });
    $("[data-tn3d-pbadge]").hidden = !(modus !== "markise" && state.markise_aktiv);
    $("[data-tn3d-pliste]").innerHTML = p.zeilen.map((z) => `<dt>${esc(z[0])}</dt><dd${z[2] ? ' class="tn3d-rabatt"' : ""}>${esc(z[1])}</dd>`).join("");
    const i = viz.getInfo();
    if (modus !== "markise") {
      $("[data-tn3d-info]").textContent = T("masse.pfosten_dachneigung", { pfosten: i.pfosten }) + (state.breite_cm > 750 ? T("masse.ab_751") : "");
      $("[data-tn3d-farbname]").textContent = T(`werte.ral.${ralCode(state.rahmenfarbe)}`);
      const wa = $("[data-tn3d-wandanschluss]");
      if (wa) wa.innerHTML = T("masse.wandanschluss_hinweis", { cm: i.wandanschlussCm }) + ` <a href="${esc(root_)}blogs/ratgeber/terrassenueberdachung-gefaelle-entwaesserung">${esc(T("masse.mehr_zum_gefaelle"))}</a>`;
    }
    lieferumfang.render(modus, state, i);
    $$(".tn3d-opts, .tn3d-seg").forEach((gr) => {
      const k = gr.dataset.key;
      const wert = k === "dach" ? `${state.material}:${state.ausfuehrung}` : state[k];
      gr.querySelectorAll("button").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.v === wert)));
    });
  }
  let vizTimer;
  function set(p, sofort) {
    Object.assign(state, p);
    hideError();
    anzeigen();
    clearTimeout(vizTimer);
    const run = () => {
      viz.update(vizParams());
      anzeigen();
    };
    sofort ? run() : vizTimer = setTimeout(run, 40);
  }
  const viewerEl = $("[data-tn3d-viewer]");
  const tipEl = document.createElement("div");
  tipEl.className = "tn3d-tip";
  tipEl.hidden = true;
  tipEl.innerHTML = `<button type="button" class="tn3d-tip-schliessen" aria-label="${esc(T("allgemein.schliessen"))}">×</button><div class="tn3d-tip-inhalt"></div>`;
  viewerEl.appendChild(tipEl);
  const tipInhalt = tipEl.querySelector(".tn3d-tip-inhalt");
  const istMobilViewer = () => matchMedia("(max-width: 749px)").matches;
  function teilZeilen(info) {
    const rows = [];
    if (info.artikelnr) rows.push([T("tooltip.art_nr"), info.artikelnr]);
    if (info.querschnitt) rows.push([T("tooltip.querschnitt"), info.querschnitt]);
    if (info.wandstaerke) rows.push([T("tooltip.wandstaerke"), info.wandstaerke]);
    if (info.laengeCm) rows.push([T("tooltip.laenge"), T("tooltip.laenge_ca", { cm: info.laengeCm })]);
    if (info.gewichtKg) rows.push([T("tooltip.gewicht"), info.stueck ? T("tooltip.gewicht_stk", { kg: kg.format(info.gewichtKg) }) : T("tooltip.gewicht_ca", { kg: kg.format(info.gewichtKg) })]);
    if (info.farbe) rows.push([T("tooltip.farbe"), info.farbe]);
    return rows;
  }
  function zeigeTip(info, x, y) {
    const rows = teilZeilen(info);
    tipInhalt.innerHTML = `<p class="tn3d-tip-titel">${esc(info.bezeichnung)}</p>` + (rows.length ? `<dl class="tn3d-tip-liste">${rows.map((r) => `<dt>${esc(r[0])}</dt><dd>${esc(r[1])}</dd>`).join("")}</dl>` : "");
    tipEl.hidden = false;
    if (istMobilViewer() || x == null) {
      tipEl.style.left = tipEl.style.top = tipEl.style.right = "";
      return;
    }
    const rect = viewerEl.getBoundingClientRect();
    let lx = x - rect.left + 16, ly = y - rect.top + 16;
    tipEl.style.left = lx + "px";
    tipEl.style.top = ly + "px";
    requestAnimationFrame(() => {
      const tw = tipEl.offsetWidth, th = tipEl.offsetHeight;
      tipEl.style.left = Math.max(8, Math.min(lx, rect.width - tw - 8)) + "px";
      tipEl.style.top = Math.max(8, Math.min(ly, rect.height - th - 8)) + "px";
    });
  }
  function versteckeTip() {
    tipEl.hidden = true;
  }
  tipEl.querySelector(".tn3d-tip-schliessen").addEventListener("click", () => {
    versteckeTip();
    viz.clearHover();
  });
  const viz = new TerrneeVisualizer(viewerEl, vizParams(), {
    assetBase: base,
    kulisse: cfg.kulisse || "neutral",
    masse: true,
    stoffUrls: cfg.stoffBilder || {},
    umgebung: cfg.umgebung === true,
    T,
    onTeil: (info, x, y) => info ? zeigeTip(info, x, y) : versteckeTip()
  });
  const luContainer = document.createElement("div");
  root.insertAdjacentElement("afterend", luContainer);
  const lieferumfang = erstelleLieferumfang(luContainer, {
    onZeileKlick: (teil) => viz.focusTeil(teil),
    infoZeilen: (teil) => teilZeilen(viz.infoFuerTeil(teil) || {}),
    T,
    root: root_
  });
  $$("[data-feld]").forEach((f) => {
    const k = f.dataset.feld, inp = f.querySelector("[data-input]"), rg = f.querySelector("[data-range]");
    const clamp = (v) => {
      const [mn, mx] = grenzen()[k];
      return Math.min(mx, Math.max(mn, Math.round(v)));
    };
    inp.addEventListener("change", () => {
      const v = parseFloat(inp.value);
      set({ [k]: clamp(isNaN(v) ? state[k] : v) });
      inp.value = state[k];
    });
    inp.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        inp.blur();
      }
    });
    rg.addEventListener("input", () => {
      inp.value = rg.value;
      set({ [k]: +rg.value });
    });
    f.querySelectorAll("[data-step]").forEach((b) => b.addEventListener("click", () => {
      const schritt = k === "anzahl" ? 1 : k === "breite_cm" || k === "tiefe_cm" ? 10 : 1;
      set({ [k]: clamp(state[k] + schritt * +b.dataset.step) });
    }));
  });
  $$(".tn3d-opts, .tn3d-seg").forEach((gr) => {
    const k = gr.dataset.key;
    gr.querySelectorAll("button").forEach((b) => b.addEventListener("click", () => {
      if (k === "dach") {
        const [m, a] = b.dataset.v.split(":");
        set({ material: m, ausfuehrung: a }, true);
      } else set({ [k]: b.dataset.v }, true);
    }));
  });
  const mk = $("[data-tn3d-markise]");
  if (mk) mk.addEventListener("change", () => {
    $("[data-tn3d-markisebox]").hidden = !mk.checked;
    set({ markise_aktiv: mk.checked }, true);
  });
  const led = $("[data-tn3d-led]");
  if (led) led.addEventListener("change", () => {
    $("[data-tn3d-ledbox]").hidden = !led.checked;
    set({ led_aktiv: led.checked }, true);
  });
  const bm = $("[data-tn3d-masse]");
  bm.addEventListener("click", () => {
    const an = bm.getAttribute("aria-pressed") !== "true";
    bm.setAttribute("aria-pressed", String(an));
    viz.setMasse(an);
  });
  $("[data-tn3d-reset]").addEventListener("click", () => viz.resetView());
  const kBtns = $$(".tn3d-kulissen button");
  const setK = (k) => {
    kBtns.forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.k === k)));
    viz.setKulisse(k);
  };
  kBtns.forEach((b) => b.addEventListener("click", () => setK(b.dataset.k)));
  kBtns.forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.k === (cfg.kulisse || "neutral"))));
  const fehler = $("[data-tn3d-fehler]");
  function showError(msg) {
    fehler.textContent = msg;
    fehler.hidden = false;
    fehler.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }
  function hideError() {
    fehler.hidden = true;
  }
  const ctas = $$("[data-tn3d-cta]");
  function busy(text) {
    ctas.forEach((b) => {
      b.disabled = !!text;
      b.querySelector("span").textContent = text || T("preis.in_den_warenkorb");
    });
  }
  ctas.forEach((btn) => btn.addEventListener("click", () => {
    hideError();
    const api = window.TDKonfigCart;
    if (!api) return showError(T("warenkorb.laden_fehler"));
    if (!cfg.workerUrl) return showError(T("warenkorb.backend_fehlt"));
    const w = cfg.workerUrl.replace(/\/$/, "");
    busy(T("preis.konfiguration_wird_geprueft"));
    let auftrag;
    if (modus === "markise") {
      const props = {
        [T("warenkorb.masse_b_l")]: state.bahnbreite_cm * state.anzahl + " × " + state.bahnlaenge_cm + " cm",
        [T("warenkorb.bahnen")]: state.anzahl + " × " + state.bahnbreite_cm + " cm",
        [T("warenkorb.tuchfarbe")]: T(`werte.tuchfarbe.${state.tuchfarbe.replace("ß","ss")}`),
        [T("warenkorb.bedienung")]: T("warenkorb.bedienung_wert")
      };
      props["_Konfiguration DE"] = `Maße (B × L): ${state.bahnbreite_cm * state.anzahl} × ${state.bahnlaenge_cm} cm; Bahnen: ${state.anzahl} × ${state.bahnbreite_cm} cm; Tuchfarbe: ${state.tuchfarbe}; Bedienung: per Hand (Bedienstab)`;
      props["_Sprache"] = sprache;
      auftrag = api.callWorker(w + "/configure-markise", {
        bahnbreite_cm: state.bahnbreite_cm,
        bahnlaenge_cm: state.bahnlaenge_cm,
        anzahl_bahnen: state.anzahl,
        tuchfarbe: state.tuchfarbe
      }).then((c) => api.addToCart([{ id: c.variantLegacyId, quantity: 1, properties: props }])).then((res) => ({ res, product: T("warenkorb.produkt_markise"), groups: [{ rows: Object.entries(props).filter(([k]) => !k.startsWith("_")) }] }));
    } else {
      const s = state;
      const set2 = s.markise_aktiv;
      const setLabel = T("warenkorb.set_label");
      const ledTextDisplay = s.led_aktiv ? T("warenkorb.led_mit", { farbe: T(s.led_farbe === "6000K" ? "werte.kaltweiss" : "werte.warmweiss") + " " + (s.led_farbe === "6000K" ? "6000 K" : "3000 K"), montage: T(s.led_montage === "vormontiert" ? "werte.vormontiert" : "werte.lose_beigelegt") }) : T("warenkorb.led_ohne");
      const wandanschlussWert = wandanschlussCm(s.pfostenhoehe_cm, s.tiefe_cm);
      const dachProps = {
        [T("zusammenfassung.breite") + " × " + T("zusammenfassung.tiefe")]: s.breite_cm + " × " + s.tiefe_cm + " cm",
        [T("warenkorb.dach")]: T(s.material === "glas" ? "werte.material.glas" : "werte.material.polycarbonat") + " · " + T(`werte.ausfuehrung.${s.ausfuehrung}`),
        [T("warenkorb.rahmenfarbe")]: s.rahmenfarbe,
        [T("warenkorb.zierblende")]: T(`werte.zierblende.${s.zierblende}`),
        [T("warenkorb.led")]: ledTextDisplay,
        [T("warenkorb.montage")]: T("warenkorb.montage_wert", { cm: cfg.pfostenhoeheCm }),
        [T("warenkorb.wandanschluss")]: T("warenkorb.wandanschluss_ca", { cm: wandanschlussWert })
      };
      if (set2) dachProps[T("warenkorb.set")] = setLabel;
      const ledTextDE = s.led_aktiv ? `mit · ${s.led_farbe === "6000K" ? "kaltweiß 6000 K" : "warmweiß 3000 K"} · ${s.led_montage === "vormontiert" ? "vormontiert" : "lose beigelegt"}` : "ohne";
      dachProps["_Konfiguration DE"] = `Maße (B × T): ${s.breite_cm} × ${s.tiefe_cm} cm; Dach: ${s.material === "glas" ? "Glas VSG 8 mm" : "Polycarbonat 16 mm"} · ${s.ausfuehrung}; Rahmenfarbe: ${s.rahmenfarbe}; Zierblende: ${s.zierblende}; LED: ${ledTextDE}; Montage: Wandanbau · Pfosten ${cfg.pfostenhoeheCm} cm; Wandanschluss: ca. ${wandanschlussWert} cm`;
      dachProps["_Sprache"] = sprache;
      const dachBody = {
        breite_m: s.breite_cm / 100,
        tiefe_m: s.tiefe_cm / 100,
        material: s.material,
        poly_variante: s.material === "polycarbonat" ? s.ausfuehrung : null,
        glas_variante: s.material === "glas" ? s.ausfuehrung : null,
        rahmenfarbe: s.rahmenfarbe,
        regenrinnen_optik: s.zierblende,
        led_aktiv: s.led_aktiv,
        led_montage: s.led_aktiv ? s.led_montage : null,
        led_farbe: s.led_aktiv ? s.led_farbe : null,
        bundle: set2
      };
      const jobs = [api.callWorker(w + "/configure", dachBody)];
      let markiseProps = null;
      if (set2) {
        const n = felderGleichmaessig(s.breite_cm, s.material).length;
        markiseProps = {
          [T("warenkorb.ausfuehrung")]: T("warenkorb.ausfuehrung_wert", { breite: s.breite_cm, tiefe: s.tiefe_cm }),
          [T("warenkorb.tuchfarbe")]: T(`werte.tuchfarbe.${s.tuchfarbe.replace("ß","ss")}`),
          [T("warenkorb.bedienung")]: T("warenkorb.bedienung_wert"),
          [T("warenkorb.set")]: setLabel
        };
        markiseProps["_Konfiguration DE"] = `Ausführung: passgenau zur Überdachung ${s.breite_cm} × ${s.tiefe_cm} cm; Tuchfarbe: ${s.tuchfarbe}; Bedienung: per Hand (Bedienstab)`;
        markiseProps["_Sprache"] = sprache;
        jobs.push(api.callWorker(w + "/configure-markise", {
          bahnbreite_cm: preisCfg.markiseKalkBahnCm,
          bahnlaenge_cm: s.tiefe_cm,
          anzahl_bahnen: n,
          tuchfarbe: s.tuchfarbe,
          bundle: true,
          passgenau: true,
          terrasse_breite_cm: s.breite_cm,
          terrasse_tiefe_cm: s.tiefe_cm,
          material: s.material
        }));
      }
      auftrag = Promise.all(jobs).then((c) => {
        busy(T("preis.wird_in_warenkorb_gelegt"));
        const items = [{ id: c[0].variantLegacyId, quantity: 1, properties: dachProps }];
        if (set2) items.push({ id: c[1].variantLegacyId, quantity: 1, properties: markiseProps });
        return api.addToCart(items);
      }).then((res) => {
        const rows = (p) => Object.entries(p).filter(([k]) => k !== T("warenkorb.set") && !k.startsWith("_"));
        return set2 ? { res, product: T("warenkorb.produkt_komplett"), groups: [{ title: T("warenkorb.gruppe_terrasse"), rows: rows(dachProps) }, { title: T("warenkorb.gruppe_markise"), rows: rows(markiseProps) }] } : { res, product: T("warenkorb.produkt_terrasse"), groups: [{ rows: rows(dachProps) }] };
      });
    }
    auftrag.then(({ res, product, groups }) => {
      busy(null);
      api.showSuccess({ product, groups, addedItems: res.added, cart: res.cart });
    }).catch((err) => {
      busy(null);
      showError(err && err.message || T("warenkorb.allgemeiner_fehler"));
    });
  }));
  function baueZusammenfassung() {
    const p = preis();
    const i = viz.getInfo();
    const configURL = configZuLink(modus, state);
    if (modus === "markise") {
      return {
        modus,
        konfiguratorName: T("zusammenfassung.konfigurator_markise"),
        konfiguratorNameDE: "Seilspannmarkise",
        titelKurz: `${state.anzahl} × ${state.bahnbreite_cm} × ${state.bahnlaenge_cm} cm`,
        zeilen: [
          [T("zusammenfassung.anzahl_bahnen"), String(state.anzahl)],
          [T("zusammenfassung.breite_je_bahn"), state.bahnbreite_cm + " cm"],
          [T("zusammenfassung.laenge"), state.bahnlaenge_cm + " cm"],
          [T("zusammenfassung.stofffarbe"), T(`werte.tuchfarbe.${state.tuchfarbe.replace("ß","ss")}`)]
        ],
        zeilenDE: [
          ["Anzahl Bahnen", String(state.anzahl)],
          ["Breite je Bahn", state.bahnbreite_cm + " cm"],
          ["Länge", state.bahnlaenge_cm + " cm"],
          ["Stofffarbe", state.tuchfarbe]
        ],
        preisZeilen: p.zeilen,
        preisGesamt: p.gesamt,
        configURL,
        dateiSuffix: `Seilspannmarkise_${state.anzahl}x${state.bahnbreite_cm}x${state.bahnlaenge_cm}cm`,
        dateiSuffixUebersetzt: `${T("pdf.dateiname_markise")}_${state.anzahl}x${state.bahnbreite_cm}x${state.bahnlaenge_cm}cm`
      };
    }
    const farbeLabel = T(`werte.ral.${ralCode(state.rahmenfarbe)}`);
    const farbeLabelDE = (RAL[ralCode(state.rahmenfarbe)] || {}).name || state.rahmenfarbe;
    return {
      modus,
      konfiguratorName: state.markise_aktiv ? T("zusammenfassung.konfigurator_komplett") : T("zusammenfassung.konfigurator_terrasse"),
      konfiguratorNameDE: state.markise_aktiv ? "Komplettsystem" : "Terrassenüberdachung",
      titelKurz: `${state.breite_cm} × ${state.tiefe_cm} cm`,
      zeilen: [
        [T("zusammenfassung.breite"), state.breite_cm + " cm"],
        [T("zusammenfassung.tiefe"), state.tiefe_cm + " cm"],
        [T("zusammenfassung.durchgangshoehe"), state.pfostenhoehe_cm + " cm"],
        [T("zusammenfassung.wandanschlusshoehe"), T("zusammenfassung.wandanschlusshoehe_wert", { cm: i.wandanschlussCm })],
        [T("zusammenfassung.dachneigung"), T("zusammenfassung.dachneigung_wert")],
        [T("zusammenfassung.pfosten"), String(i.pfosten)],
        [T("zusammenfassung.rahmenfarbe"), farbeLabel],
        [T("zusammenfassung.zierblende"), T(`werte.zierblende.${state.zierblende}`)],
        [T("zusammenfassung.dacheindeckung"), T(state.material === "glas" ? "werte.material.glas" : "werte.material.polycarbonat") + " · " + T(`werte.ausfuehrung.${state.ausfuehrung}`)],
        [T("zusammenfassung.seilspannmarkise"), state.markise_aktiv ? T("zusammenfassung.seilspannmarkise_ja", { farbe: T(`werte.tuchfarbe.${state.tuchfarbe.replace("ß","ss")}`) }) : T("allgemein.nein")],
        [T("zusammenfassung.led"), state.led_aktiv ? T("zusammenfassung.led_wert", { farbe: T(state.led_farbe === "6000K" ? "werte.kaltweiss" : "werte.warmweiss") + " " + (state.led_farbe === "6000K" ? "6000 K" : "3000 K"), montage: T(state.led_montage === "vormontiert" ? "werte.vormontiert" : "werte.lose_beigelegt") }) : T("allgemein.nein")]
      ],
      zeilenDE: [
        ["Breite", state.breite_cm + " cm"],
        ["Tiefe", state.tiefe_cm + " cm"],
        ["Durchgangshöhe", state.pfostenhoehe_cm + " cm"],
        ["Wandanschlusshöhe", "voraussichtlich ca. " + i.wandanschlussCm + " cm"],
        ["Dachneigung", "8°"],
        ["Pfosten", String(i.pfosten)],
        ["Rahmenfarbe", farbeLabelDE],
        ["Zierblende", state.zierblende],
        ["Dacheindeckung", (state.material === "glas" ? "Glas VSG 8 mm" : "Polycarbonat 16 mm") + " · " + state.ausfuehrung],
        ["Seilspannmarkise", state.markise_aktiv ? "ja · " + state.tuchfarbe : "nein"],
        ["LED", state.led_aktiv ? `${state.led_farbe === "6000K" ? "kaltweiß 6000 K" : "warmweiß 3000 K"} · ${state.led_montage === "vormontiert" ? "vormontiert" : "lose beigelegt"}` : "nein"]
      ],
      preisZeilen: p.zeilen,
      preisGesamt: p.gesamt,
      configURL,
      dateiSuffix: `${state.breite_cm}x${state.tiefe_cm}cm`
    };
  }
  const angebotModal = erstelleAngebotModal({ sectionId: cfg.sectionId, angebotFormId: cfg.angebotFormId, T, sprache, root: root_ });
  $$("[data-tn3d-angebot]").forEach((btn) => btn.addEventListener("click", () => angebotModal.open(baueZusammenfassung())));
  $$("[data-tn3d-pdf]").forEach((btn) => btn.addEventListener("click", () => {
    const span = btn.querySelector("span");
    const textVorher = span.textContent;
    btn.disabled = true;
    span.textContent = T("preis.pdf_wird_erstellt");
    exportierePdf(baueZusammenfassung(), { viz, logoUrl: cfg.logoUrl, firma: cfg.firma, modus, state, info: viz.getInfo(), bauListen, T, sprache }).catch(() => {
      showError(T("warenkorb.allgemeiner_fehler"));
    }).finally(() => {
      btn.disabled = false;
      span.textContent = textVorher;
    });
  }));
  if (pruefeKontaktRueckkehr()) {
    const banner = document.createElement("p");
    banner.className = "tn3d-rueckkehr-banner";
    banner.textContent = T("angebot.erfolg_titel");
    root.insertAdjacentElement("beforebegin", banner);
  }
  if (mk) {
    mk.checked = !!state.markise_aktiv;
    $("[data-tn3d-markisebox]").hidden = !state.markise_aktiv;
  }
  if (led) {
    led.checked = !!state.led_aktiv;
    $("[data-tn3d-ledbox]").hidden = !state.led_aktiv;
  }
  anzeigen();
  root.classList.add("is-ready");
  root.__tn3dState = state;
  root.__tn3dViz = viz;
}
function start() {
  document.querySelectorAll("[data-tn3d]").forEach(init);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();
document.addEventListener("shopify:section:load", start);
